
      import LeftRightStructure from './left-right-structure.vue'
      import type { App, Plugin } from 'vue'

      export const LeftRightStructurePlugin: Plugin = {
        install(app: App) {
          app.component('LeftRightStructure', LeftRightStructure)
        },
      }
      export { LeftRightStructure }
      